<h3>Edit Images</h3>
<span>(Max 15, 5MB each)</span>

<mat-dialog-content>
  <div class="upload-area">
    <!-- DROP ZONE -->
    <div class="drop-zone"
         (drop)="onDrop($event)"
         (dragover)="onDragOver($event)"
         [class.active]="allImages.length < maxImages">
      <p *ngIf="allImages.length < maxImages">
        Drop images here or
        <label class="browse-btn">
          browse
          <input type="file" multiple accept="image/*" (change)="onImagesSelected($event)" />
        </label>
      </p>
      <p *ngIf="allImages.length >= maxImages" class="limit">
        Max {{ maxImages }} images reached
      </p>
    </div>

    <!-- IMAGE GRID -->
    <div class="image-preview-grid">
      <div cdkDropList
           [cdkDropListData]="allImages"
           (cdkDropListDropped)="onDropImage($event)"
           class="drop-list">

        <div *ngFor="let image of allImages; let i = index"
             class="image-preview-item"
             cdkDrag
             [cdkDragData]="image">

          <div class="image-list-custom-placeholder" *cdkDragPlaceholder></div>

          <ng-template cdkDragPreview let-img="cdkDragData">
            <div class="image-preview-item preview">
              <img [src]="getPreview(img)" alt="" />
            </div>
          </ng-template>

          <img [src]="getPreview(image)" [alt]="'Image ' + (i + 1)" />

          <button mat-icon-button class="remove-btn" (click)="removeImage(i)">
            <mat-icon>close</mat-icon>
          </button>

          <div class="drag-handle" cdkDragHandle>
            <mat-icon>drag_handle</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isProcessingImages" class="processing">
      <mat-progress-spinner diameter="24"
                            mode="determinate"
                            [value]="(processedImages / totalImages) * 100">
      </mat-progress-spinner>
      <span>Processing {{ processedImages }} of {{ totalImages }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- <button mat-raised-button color="warning" (click)="cancel()">
    <mat-icon matPrefix>cancel</mat-icon>Cancel
  </button>

  <button mat-raised-button color="primary"
          (click)="save()"
          [disabled]="isProcessing || allImages.length === 0">
    Save
    <mat-spinner diameter="20" *ngIf="isProcessing"></mat-spinner>
  </button> -->
  <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
  <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save()" [disabled]="isProcessing || allImages.length === 0"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>